module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_live_retouch-8d577271f3fed631fbceb341d8493a82.jpg";